import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthorization } from './useAuthorization';
import AccessDeniedPage from './AccessDeniedPage';
import { ROUTES } from '../constants/routes';

/**
 * @param {{ access?: import('./types/authz.types').AuthzRequirement, children: React.ReactNode, fallback?: React.ReactNode }} props
 */
export default function RequireAccess({ access, children, fallback = <AccessDeniedPage /> }) {
  const { can } = useAuthorization();

  if (!can(access ?? null)) {
    return fallback;
  }

  return <>{children}</>;
}

/**
 * Route-level helper when token check is handled elsewhere.
 */
export function RequireAccessRedirect({ access, to = ROUTES.APP.ACCESS_DENIED }) {
  const { can } = useAuthorization();
  if (!can(access ?? null)) {
    return <Navigate to={to} replace />;
  }
  return null;
}
